import { useCheckUserType } from '@/src/hooks/check_user'
import { RootState } from '@/src/redux/store'
import { useSelector } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
import { CommonPage } from './carousel/page'
type Props = {
  setSelectedId: (id: string) => any
}

export function SettingRoot(props: Props) {
  const { isSEOs } = useCheckUserType()
  const employee = useSelector((state: RootState) => state.employee)

  return (
    <Routes>
      {!isSEOs(employee?.employeeData?.M15_Employee_id!) &&
        <>
          <Route index element={<Navigate to='common' />} />
          <Route path='common' element={<CommonPage setSelectedId={props.setSelectedId} />} />
        </>
      }

    </Routes>
  )
}
